import { connect } from 'react-redux'
import { withRouter } from 'react-router'

import ThumbnailComponent from './ThumbnailComponent'

const mapStateToProps = () => ({})

const mapDispatchToProps = (dispatch, { router, slug }) => ({
  handleClick () {
    window.scroll({ top: 0, left: 0, behavior: 'smooth' })
    router.push({ pathname: `/gallery/${slug}` })
  },
})

const Thumbnail = withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(ThumbnailComponent)
)

export default Thumbnail



// WEBPACK FOOTER //
// ./src/gallery/components/Thumbnail.js